class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search')
          .innerHTML;

        this.predictiveSearchResults.innerHTML = resultsMarkup;

        this.sortProductsBySku();
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  sortProductsBySku() {
    const productList = this.predictiveSearchResults.querySelector(
      '.result-product-wrapper .predictive-search__results-list'
    );

    if (!productList) return;

    const searchItem = productList.querySelector(
      '#predictive-search-option-search-keywords'
    );

    const products = Array.from(
      productList.querySelectorAll('.predictive-search__product-item[data-sku]')
    );

    products.sort((a, b) => {
      return Number(a.dataset.sku) - Number(b.dataset.sku);
    });

    products.forEach(product => {
      productList.appendChild(product);
    });

    if (searchItem) {
      productList.appendChild(searchItem);
    }
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);